import type { SVGProps } from 'react'

interface InfoIconProps extends SVGProps<SVGSVGElement> {}

export function InfoIcon(props: InfoIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="currentColor"
      {...props}
    >
      <path
        id="Toltip_informativo_-_Minimalista"
        data-name="Toltip informativo - Minimalista"
        d="M16,3.5A12.5,12.5,0,1,0,28.5,16,12.514,12.514,0,0,0,16,3.5Zm0,5.125a1.625,1.625,0,1,1-1.625,1.625A1.625,1.625,0,0,1,16,8.625ZM19,22.75H13.5a1,1,0,0,1,0-2h1.75v-5.5h-1a1,1,0,0,1,0-2h2a1,1,0,0,1,1,1v6.5H19a1,1,0,0,1,0,2Z"
        transform="translate(-3.5 -3.5)"
        fill="#6ebc0a"
      />
    </svg>
  )
}
